/**
 * FBT (Frequently Bought Together) Bundle
 *
 * Handles:
 * - Checkbox toggling (select/deselect products)
 * - Variant dropdown changes → price updates
 * - Dynamic total price calculation
 * - Multi-add to cart via /cart/add.js { items: [...] }
 * - Cart drawer integration (dispatches cart:change event)
 * - Two-way flavor sync between PDP swatches and FBT main-product row
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2);
    return '₪' + amount;
  }

  function getSelectedVariant(itemEl) {
    var dataEl = itemEl.querySelector('[data-fbt-product-data]');
    if (!dataEl) return null;

    var data = JSON.parse(dataEl.textContent);
    var variantSelect = itemEl.querySelector('[data-fbt-variant-select]');
    var selectedVariantId = variantSelect
      ? parseInt(variantSelect.value, 10)
      : data.defaultVariantId;

    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === selectedVariantId) {
        return data.variants[i];
      }
    }
    return data.variants[0];
  }

  function getProductData(itemEl) {
    var dataEl = itemEl.querySelector('[data-fbt-product-data]');
    if (!dataEl) return null;
    return JSON.parse(dataEl.textContent);
  }

  function variantOptionValuesFromFbt(variant) {
    if (!variant) return [];
    var vals = [];
    if (variant.option1 != null && variant.option1 !== '') vals.push(variant.option1);
    if (variant.option2 != null && variant.option2 !== '') vals.push(variant.option2);
    if (variant.option3 != null && variant.option3 !== '') vals.push(variant.option3);
    return vals;
  }

  function findVariantInItemData(itemEl, variantId) {
    var data = getProductData(itemEl);
    if (!data || !data.variants) return null;
    var vid = parseInt(variantId, 10);
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === vid) return data.variants[i];
    }
    return null;
  }

  function applyFbtVariantById(sectionEl, itemEl, variantId) {
    var hidden = itemEl.querySelector('[data-fbt-variant-select]');
    if (!hidden) return;

    var vid = parseInt(variantId, 10);
    if (isNaN(vid)) return;

    hidden.value = String(vid);

    var dd = itemEl.querySelector('[data-fbt-dropdown]');
    if (dd) {
      var labelEl = dd.querySelector('[data-fbt-dropdown-label]');
      dd.querySelectorAll('[data-fbt-dropdown-option]').forEach(function (opt) {
        var oid = parseInt(opt.getAttribute('data-variant-id'), 10);
        var isSel = oid === vid;
        opt.classList.toggle('is-selected', isSel);
        if (isSel && labelEl) {
          labelEl.textContent = opt.textContent.trim();
        }
      });
    }

    var data = getProductData(itemEl);
    var modal = itemEl.querySelector('quick-buy-modal');
    if (modal && data && data.handle) {
      modal.setAttribute('handle', data.handle + '?variant=' + vid);
    }

    updateItemPrice(itemEl);
    updateTotal(sectionEl);
  }

  function onPageVariantChange(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var productId = form.getAttribute('data-product-id');
    if (!productId) return;
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;

    document.querySelectorAll('[data-fbt-section]').forEach(function (sectionEl) {
      sectionEl
        .querySelectorAll('[data-fbt-item][data-fbt-is-main][data-product-id="' + productId + '"]')
        .forEach(function (itemEl) {
          applyFbtVariantById(sectionEl, itemEl, variant.id);
        });
    });
  }

  function syncPageVariantPickerFromFbtItem(itemEl, variantId) {
    var data = getProductData(itemEl);
    if (!data || !data.isMainProduct) return;

    var variant = findVariantInItemData(itemEl, variantId);
    if (!variant) return;

    var form = document.querySelector('form[data-product-id="' + data.id + '"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    if (parseInt(idInput.value, 10) === parseInt(variantId, 10)) return;

    var picker = document.querySelector('variant-picker[form-id="' + form.id + '"]');
    var optionValues = variantOptionValuesFromFbt(variant);

    if (picker && typeof picker.selectCombination === 'function' && optionValues.length > 0) {
      picker.selectCombination({ optionValues: optionValues, productChange: false });
    } else {
      idInput.value = String(variant.id);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncMainFbtRowWithProductForm(sectionEl) {
    var mainItem = sectionEl.querySelector('[data-fbt-item][data-fbt-is-main]');
    if (!mainItem) return;
    var productId = mainItem.getAttribute('data-product-id');
    var form = document.querySelector('form[data-product-id="' + productId + '"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || idInput.value === '') return;
    applyFbtVariantById(sectionEl, mainItem, idInput.value);
  }

  /* =====================================================================
     FLAVOR SYNC  — PDP .flavor-checkbox  ↔  FBT [data-fbt-flavor]
     Only for the main product row (data-fbt-is-main).
     Uses data-product-id on the FBT item to match PDP flavor checkboxes.
     ===================================================================== */

  var _flavorSyncing = false;

  function getPdpFlavorCheckboxes(productId) {
    return document.querySelectorAll(
      '.product--options__wrapper .flavor-checkbox'
    );
  }

  function getFbtMainItemsForProduct(productId) {
    return document.querySelectorAll(
      '[data-fbt-section] [data-fbt-item][data-fbt-is-main][data-product-id="' + String(productId) + '"]'
    );
  }

  function copyFlavorsFromPdpToFbt(productId) {
    var pdpBoxes = getPdpFlavorCheckboxes(productId);
    if (pdpBoxes.length === 0) return;

    var checkedSet = new Set();
    pdpBoxes.forEach(function (cb) {
      if (cb.checked) checkedSet.add(cb.value);
    });

    getFbtMainItemsForProduct(productId).forEach(function (itemEl) {
      var data = getProductData(itemEl);
      if (!data || !data.hasFlavors) return;
      itemEl.querySelectorAll('[data-fbt-flavor]').forEach(function (input) {
        input.checked = checkedSet.has(input.value);
      });
      var dd = itemEl.querySelector('.fbt-bundle__flavors-dropdown');
      if (dd) updateFlavorLabel(dd);
    });
  }

  function copyFlavorsFromFbtToPdp(fbtItemEl) {
    var data = getProductData(fbtItemEl);
    if (!data || !data.isMainProduct || !data.hasFlavors) return;

    var checkedSet = new Set();
    fbtItemEl.querySelectorAll('[data-fbt-flavor]').forEach(function (input) {
      if (input.checked) checkedSet.add(input.value);
    });

    var pdpBoxes = getPdpFlavorCheckboxes(data.id);
    pdpBoxes.forEach(function (cb) {
      cb.checked = checkedSet.has(cb.value);
    });

    if (pdpBoxes.length > 0) {
      pdpBoxes[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function bindFlavorSync() {
    document.addEventListener('change', function (e) {
      if (_flavorSyncing) return;
      var t = e.target;
      if (!t || !t.matches) return;

      _flavorSyncing = true;
      try {
        if (t.matches('.flavor-checkbox')) {
          var itemContent = document.querySelector('[data-fbt-item][data-fbt-is-main]');
          if (itemContent) {
            var productId = itemContent.getAttribute('data-product-id');
            copyFlavorsFromPdpToFbt(productId);
          }
        } else if (t.matches('[data-fbt-flavor]')) {
          var fbtItem = t.closest('[data-fbt-item]');
          if (fbtItem && fbtItem.hasAttribute('data-fbt-is-main')) {
            copyFlavorsFromFbtToPdp(fbtItem);
          }
        }
      } finally {
        _flavorSyncing = false;
      }
    }, true);
  }

  /* ===================================================================== */

  function isItemSelected(itemEl) {
    var cb = itemEl.querySelector('[data-fbt-checkbox]');
    return cb ? cb.checked : false;
  }

  function updateItemPrice(itemEl) {
    var variant = getSelectedVariant(itemEl);
    if (!variant) return;

    var priceEl = itemEl.querySelector('[data-fbt-price]');
    if (!priceEl) return;

    if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
      priceEl.innerHTML =
        '<span class="fbt-bundle__sale-price">' + formatMoney(variant.price) + '</span>' +
        '<span class="fbt-bundle__compare-price">' + formatMoney(variant.compareAtPrice) + '</span>';
    } else {
      priceEl.innerHTML =
        '<span class="fbt-bundle__regular-price">' + formatMoney(variant.price) + '</span>';
    }
  }

  function calculateTotal(sectionEl) {
    var items = sectionEl.querySelectorAll('[data-fbt-item]');
    var total = 0;
    var count = 0;

    items.forEach(function (itemEl) {
      if (!isItemSelected(itemEl)) return;
      var variant = getSelectedVariant(itemEl);
      if (variant && variant.available) {
        total += variant.price;
        count++;
      }
    });

    return { total: total, count: count };
  }

  function updateTotal(sectionEl) {
    var result = calculateTotal(sectionEl);
    var totalPriceEl = sectionEl.querySelector('[data-fbt-total-price]');
    var countEl = sectionEl.querySelector('[data-fbt-selected-count]');

    if (totalPriceEl) {
      totalPriceEl.textContent = formatMoney(result.total);
    }
    if (countEl) {
      countEl.textContent = result.count + ' מוצרים נבחרו';
    }

    var ctaBtn = sectionEl.querySelector('[data-fbt-add-all]');
    if (ctaBtn) {
      ctaBtn.disabled = result.count === 0;
      if (result.count === 0) {
        ctaBtn.setAttribute('aria-busy', 'false');
      }
    }
  }

  function gatherCartItems(sectionEl) {
    var items = [];
    var itemEls = sectionEl.querySelectorAll('[data-fbt-item]');

    itemEls.forEach(function (itemEl) {
      if (!isItemSelected(itemEl)) return;

      var variant = getSelectedVariant(itemEl);
      var data = getProductData(itemEl);
      if (!variant || !variant.available || !data) return;

      var properties = {};

      if (data.hasFlavors) {
        var flavorInputs = itemEl.querySelectorAll('[data-fbt-flavor]:checked');
        var flavors = [];
        flavorInputs.forEach(function (input) {
          flavors.push(input.value);
        });
        if (flavors.length > 0) {
          properties['בחירת טעמים'] = flavors.join(', ');
        }
      }

      if (data.hasKosherDelivery) {
        var kosherInput = itemEl.querySelector('[data-fbt-kosher]');
        if (kosherInput && kosherInput.checked) {
          properties['הערת משלוח'] = 'משלוח כשר';
        }
      }

      var item = {
        id: variant.id,
        quantity: 1
      };

      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }

      items.push(item);
    });

    return items;
  }

  async function addBundleToCart(sectionEl) {
    var ctaBtn = sectionEl.querySelector('[data-fbt-add-all]');
    if (!ctaBtn) return;

    var items = gatherCartItems(sectionEl);
    if (items.length === 0) return;

    ctaBtn.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    );

    try {
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      var body = { items: items };
      if (sectionsToBundle.length > 0) {
        body.sections = sectionsToBundle;
      }

      var response = await fetch(
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        }
      );

      var responseJson = await response.json();

      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:end', { bubbles: true })
      );

      if (response.ok) {
        var cartResponse = await fetch(
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/') + 'cart.js'
        );
        var cartContent = await cartResponse.json();
        if (responseJson.sections) {
          cartContent.sections = responseJson.sections;
        }

        if (
          window.themeVariables &&
          window.themeVariables.settings &&
          window.themeVariables.settings.cartType === 'page'
        ) {
          window.location.href =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/') + 'cart';
          return;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              onSuccessDo: 'force_open_drawer',
              cart: cartContent
            }
          })
        );
      } else {
        console.error('[FBT] Cart add failed:', responseJson);
        if (responseJson.description) {
          alert(responseJson.description);
        }
      }
    } catch (err) {
      console.error('[FBT] Cart add error:', err);
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:end', { bubbles: true })
      );
    } finally {
      ctaBtn.removeAttribute('aria-busy');
    }
  }

  function closeAllDropdowns(sectionEl) {
    sectionEl.querySelectorAll('[data-fbt-dropdown][data-open]').forEach(function (dd) {
      dd.removeAttribute('data-open');
      var panel = dd.querySelector('[data-fbt-dropdown-panel]');
      if (panel) panel.hidden = true;
    });
    sectionEl.querySelectorAll('.fbt-bundle__flavors-dropdown[data-open]').forEach(function (dd) {
      dd.removeAttribute('data-open');
      var panel = dd.querySelector('[data-fbt-flavors-panel]');
      if (panel) panel.hidden = true;
    });
  }

  function updateFlavorLabel(dropdown) {
    var checked = dropdown.querySelectorAll('[data-fbt-flavor]:checked');
    var labelEl = dropdown.querySelector('[data-fbt-flavors-label]');
    if (!labelEl) return;

    if (checked.length === 0) {
      labelEl.textContent = 'בחירת טעמים';
    } else {
      var names = [];
      checked.forEach(function (input) { names.push(input.value); });
      labelEl.textContent = names.join(', ');
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;

    sectionEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-fbt-checkbox]')) {
        var item = e.target.closest('[data-fbt-item]');
        if (item) {
          if (e.target.checked) {
            item.removeAttribute('data-unchecked');
          } else {
            item.setAttribute('data-unchecked', '');
          }
        }
        updateTotal(sectionEl);
      }

      if (e.target.matches('[data-fbt-flavor]')) {
        var flavorDropdown = e.target.closest('.fbt-bundle__flavors-dropdown');
        if (flavorDropdown) updateFlavorLabel(flavorDropdown);
      }
    });

    sectionEl.addEventListener('click', function (e) {
      var variantToggle = e.target.closest('[data-fbt-dropdown-toggle]');
      if (variantToggle) {
        var dd = variantToggle.closest('[data-fbt-dropdown]');
        var panel = dd.querySelector('[data-fbt-dropdown-panel]');
        var isOpen = dd.hasAttribute('data-open');
        closeAllDropdowns(sectionEl);
        if (!isOpen) {
          dd.setAttribute('data-open', '');
          panel.hidden = false;
        }
        return;
      }

      var variantOption = e.target.closest('[data-fbt-dropdown-option]');
      if (variantOption && !variantOption.disabled) {
        var itemEl = variantOption.closest('[data-fbt-item]');
        var vid = variantOption.getAttribute('data-variant-id');

        closeAllDropdowns(sectionEl);
        applyFbtVariantById(sectionEl, itemEl, vid);
        syncPageVariantPickerFromFbtItem(itemEl, vid);
        return;
      }

      var flavorToggle = e.target.closest('[data-fbt-flavors-toggle]');
      if (flavorToggle) {
        var dd = flavorToggle.closest('.fbt-bundle__flavors-dropdown');
        var panel = dd.querySelector('[data-fbt-flavors-panel]');
        var isOpen = dd.hasAttribute('data-open');
        closeAllDropdowns(sectionEl);
        if (!isOpen) {
          dd.setAttribute('data-open', '');
          panel.hidden = false;
        }
        return;
      }

      if (!e.target.closest('[data-fbt-dropdown]') && !e.target.closest('.fbt-bundle__flavors-dropdown')) {
        closeAllDropdowns(sectionEl);
      }
    });

    var ctaBtn = sectionEl.querySelector('[data-fbt-add-all]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addBundleToCart(sectionEl);
      });
    }

    var carousel = sectionEl.querySelector('.fbt-bundle__children--carousel');
    var prevBtn = sectionEl.querySelector('[data-fbt-carousel-prev]');
    var nextBtn = sectionEl.querySelector('[data-fbt-carousel-next]');

    if (carousel && prevBtn && nextBtn) {
      var isRTL = getComputedStyle(carousel).direction === 'rtl';

      function getScrollPos() {
        return Math.abs(carousel.scrollLeft);
      }

      function getMaxScroll() {
        return carousel.scrollWidth - carousel.clientWidth;
      }

      function updateCarouselButtons() {
        var pos = getScrollPos();
        var max = getMaxScroll();
        prevBtn.disabled = pos <= 2;
        nextBtn.disabled = pos >= max - 2;
      }

      function getScrollStep() {
        var firstItem = carousel.querySelector('.fbt-bundle__item');
        if (!firstItem) return 200;
        var gap = parseFloat(getComputedStyle(carousel).gap) || 12;
        return firstItem.offsetWidth + gap;
      }

      prevBtn.addEventListener('click', function () {
        var delta = getScrollStep();
        carousel.scrollBy({ left: isRTL ? delta : -delta, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        var delta = getScrollStep();
        carousel.scrollBy({ left: isRTL ? -delta : delta, behavior: 'smooth' });
      });

      carousel.addEventListener('scroll', updateCarouselButtons, { passive: true });

      requestAnimationFrame(function () {
        updateCarouselButtons();
      });
    }

    syncMainFbtRowWithProductForm(sectionEl);

    var mainForFlavors = sectionEl.querySelector('[data-fbt-item][data-fbt-is-main]');
    if (mainForFlavors) {
      var pdata = getProductData(mainForFlavors);
      if (pdata && pdata.hasFlavors) {
        copyFlavorsFromPdpToFbt(pdata.id);
      }
    }

    updateTotal(sectionEl);
  }

  function init() {
    document.addEventListener('variant:change', onPageVariantChange);
    bindFlavorSync();
    var sections = document.querySelectorAll('[data-fbt-section]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
